import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect, matchPath } from 'react-router-dom';
import esEs from 'antd/lib/locale-provider/es_ES';
import { isEmpty, get } from 'lodash';
import { LocaleProvider } from 'antd';
import ModalContextProvider from '../globals/ModalContext';
import ModalRoot from '../globals/ModalRoot';
import { Loading } from '../common';
import SidebarLayout from '../layouts/Sidebar';
import { routes, routesWithoutSidebar } from './routes';
import NewOrdersNotification from '../globals/Notifications/NewOrdersNotification';

const verifyPathWithSidebar = () => {
    const pathname = window.location.pathname;
    let isMatch = false;

    routesWithoutSidebar.forEach(item => {
        const match = matchPath(pathname, {
            path: item.path,
            exact: true,
            strict: false
        });

        if (match) isMatch = true;
    });

    return !isMatch;
};

const Routes = (props) => {
    const isAuthenticated = !isEmpty(get(props, 'session.session'))

    return <>
        {isAuthenticated && <NewOrdersNotification {...props} />}
        <Router>
            <LocaleProvider locale={esEs}>
                <ModalContextProvider>
                    <Suspense fallback={<Loading />}>
                        <SidebarLayout {...props} withSidebar={verifyPathWithSidebar()}>
                            <Switch>
                                {routesWithoutSidebar.map((route, i) =>
                                    <Route
                                        exact
                                        key={i}
                                        path={route.path}
                                        render={(routeProps) => <route.component {...routeProps} {...props} />}
                                    />)}
                                {routes.map((route, i) =>
                                    <Route
                                        exact
                                        key={i}
                                        path={route.path}
                                        render={(routeProps) => <route.component {...routeProps} {...props} />}
                                    />)}
                                <Route render={() => <Redirect to='/orders-monitor' />} />
                            </Switch>
                        </SidebarLayout>
                        <ModalRoot />
                    </Suspense>
                </ModalContextProvider>
            </LocaleProvider>
        </Router>
    </>
};

export default Routes;
